import React from 'react';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { useParams, useSearchParams } from 'react-router-dom';
import { Pagination } from '../../../Components/react/Pagination';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../constants/searchParamKeys';
import { useAlgoliaAppContext } from '../../hooks/useAlgoliaAppContext';
const loc = window.location;
export const PaginationBlock = () => {
    const { pagePath } = useAlgoliaAppContext();
    const { nbPages } = useAlgoliaDataContext();
    const { handle } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    if (nbPages < 2) {
        return null;
    }
    const page = +(searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1);
    return (React.createElement("div", { className: "mb:40" },
        React.createElement(Pagination, { totalPages: nbPages, currentPage: page, setPageFunction: (page) => {
                if (page > 1) {
                    searchParams.set(SEARCH_PARAM_KEY_PAGE_NUMBER, String(page));
                }
                else {
                    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
                }
                searchParams.sort();
                setSearchParams(searchParams);
            }, ...pagePath === 'collections' && handle !== undefined &&
                {
                    linkTemplateForPageNumber: (p) => {
                        return p === 1
                            ? `${loc.origin}/collections/${handle}`
                            : `${loc.origin}/collections/${handle}?${SEARCH_PARAM_KEY_PAGE_NUMBER}=${p}`;
                    }
                } })));
};
